import { useContext } from "react";

import { ResponsivenessContext } from "@/providers/ResponsivenessProvider.tsx";

export const useResponsiveness = () => {
  const context = useContext(ResponsivenessContext);
  if (context === undefined) {
    throw new Error(
      "useResponsiveness must be used within ResponsivenessProvider",
    );
  }
  return context;
};
